import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';

const PortalSettings: React.FC = () => {
    const settings: SettingsSettingType[] = [
        // {
        //     title: 'Logo',
        //     explanationText: 'Upload hier het logo dat bovenaan de portal pagina wordt getoond. Als er geen logo is ingesteld, wordt de bedrijfsnaam getoond.',
        //     fields: [
        //         {
        //             type: 'image',
        //             name: 'portal_logo',
        //             label: 'Portaal logo',
        //         }
        //     ]
        // },
        {
            title: 'proposal.portal_settings.colors_title',
            scope: 'division',
            explanationText: 'proposal.portal_settings.colors_explanation',
            fields: [
                {
                    type: 'text',
                    label: 'proposal.portal_settings.nav_bar_color_label',
                    name: 'portal_nav_color',
                    placeholder: '#ffffff',
                    group: 'field-row',
                    width: '30%',
                    shouldAutoFocus: false,
                },
                {
                    type: 'text',
                    label: 'proposal.portal_settings.background_color_label',
                    name: 'portal_background_color',
                    placeholder: '#f6f6f6',
                    group: 'field-row',
                    width: '30%',
                    shouldAutoFocus: false,
                },
                {
                    type: 'text',
                    label: 'proposal.portal_settings.button_color_label',
                    name: 'portal_button_color',
                    placeholder: '#2BBF54',
                    group: 'field-row',
                    width: '30%',
                    shouldAutoFocus: false,
                },
            ]
        },
        {
            title: 'proposal.portal_settings.font_title',
            scope: 'division',
            explanationText: 'proposal.portal_settings.font_explanation',
            fields: [
                {
                    type: 'dropdown',
                    name: 'portal_font',
                    allowNoneOption: false,
                    showSearch: false,
                    hardcodedOptions: [
                        { value: 'arial', name: 'Arial' },
                        { value: 'helvetica', name: 'Helvetica' },
                        { value: 'times_new_roman', name: 'Times New Roman' },
                        { value: 'verdana', name: 'Verdana' },
                        { value: 'georgia', name: 'Georgia' },
                        { value: 'tahoma', name: 'Tahoma' },
                    ]
                }
            ]
        },
    ];

    return (
        <SettingsContainer settings={settings} />
    );
};

export default PortalSettings;
